// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-search-input .ant-input-outlined {
  background-color: rgb(236, 235, 235) !important;
  color: black !important;
  border-color: rgb(151, 146, 146);
  font-family: 'poppins';
}

:where(.css-dev-only-do-not-override-14i19y2).ant-select-outlined:not(
    .ant-select-customize-input
  )
  .ant-select-selector {
  border: 1px solid rgb(196, 196, 196);
  background-color: rgb(236, 235, 235) !important;
  color: black !important;
  font-family: 'poppins';
}

.custom-datatime-input .ant-input-outlined,
.custom-datatime-input .ant-picker-input input {
  background-color: rgb(236, 235, 235) !important;
  color: black !important;
  font-family: 'poppins';
}
`, "",{"version":3,"sources":["webpack://./src/page/FilterPage/FilterPage.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;;EAIE,oCAAoC;EACpC,+CAA+C;EAC/C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,+CAA+C;EAC/C,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".custom-search-input .ant-input-outlined {\n  background-color: rgb(236, 235, 235) !important;\n  color: black !important;\n  border-color: rgb(151, 146, 146);\n  font-family: 'poppins';\n}\n\n:where(.css-dev-only-do-not-override-14i19y2).ant-select-outlined:not(\n    .ant-select-customize-input\n  )\n  .ant-select-selector {\n  border: 1px solid rgb(196, 196, 196);\n  background-color: rgb(236, 235, 235) !important;\n  color: black !important;\n  font-family: 'poppins';\n}\n\n.custom-datatime-input .ant-input-outlined,\n.custom-datatime-input .ant-picker-input input {\n  background-color: rgb(236, 235, 235) !important;\n  color: black !important;\n  font-family: 'poppins';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
